class BespokeForm extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.selectedProduct = null
    this.uploadedFileUrl = null
    this.collectionHandle = window.collectionHandleToFilter || false
    this.imageBase64 = null

    this.fetchInitialProducts()
  }

  setupListeners () {
    super.setupListeners()

    this.handleFormSubmit = this.handleFormSubmit.bind(this)
    this.handleSelectChange = this.handleSelectChange.bind(this)
    this.handleProductItemClick = this.handleProductItemClick.bind(this)
    this.handleFileChange = this.handleFileChange.bind(this)

    if (this?.els?.form?.exists) {
      this.listeners.add(
        this.els.form.element,
        'submit',
        this.handleFormSubmit,
      )
    }

    const dropdowns = this.querySelectorAll('.frm-Form_Select')
    dropdowns.forEach((dropdown) => {
      dropdown.addEventListener('change', this.handleSelectChange)
    })

    const gridItems = this.querySelectorAll('.frm-Form_GridItem')
    gridItems.forEach((gridItem) => {
      gridItem.addEventListener('click', this.handleGridItemClick)
    })

    if (this.els['file-upload'].exists) {
      this.els['file-upload'].element.addEventListener(
        'change',
        this.handleFileChange,
      )
    }
  }

  handleSelectChange (e) {
    const selectElement = e.target.id
    const selectedOption = e.target.selectedOptions[0]
    const selectedValue = e.target.value
    const selectedFilter = selectedOption.dataset.filter
    const filterParams = `${selectedFilter}=${selectedValue}`
    const ringSizesDropdown = this.querySelector('.frm-Form_RingSizesField')

    if (selectedValue === 'ring' || selectElement === 'BespokeFormRingSizes') {
      ringSizesDropdown.style.display = 'block'
      this.els['ring-size']?.element.setAttribute('required', true)
    } else {
      ringSizesDropdown.style.display = 'none'
      this.els['ring-size']?.element.removeAttribute('required')
    }

    this.filterProducts(filterParams)
  }

  async handleFileChange (e) {
    const file = e.target.files[0]

    this.els['file-upload'].element.classList.remove('frm-Form_FileInput-done')

    const fileLabel = this.els['file-upload-label'].element

    fileLabel.classList.remove('frm-Form_FileInputLabel-uploaded')
    fileLabel.classList.remove('frm-Form_FileInputLabel-error')

    fileLabel.textContent = window.bespokeFormStrings.uploading

    // Validate the file type and size.
    const allowedTypes = ['image/jpeg', 'image/png', 'image/gif']
    const maxSize = 5 * 1024 * 1024 // 5MB

    if (!allowedTypes.includes(file.type)) {
      e.target.value = ''
      fileLabel.textContent = window.bespokeFormStrings.invalidFileType
      fileLabel.classList.add('frm-Form_FileInputLabel-error')
      return
    }

    if (file.size > maxSize) {
      e.target.value = ''
      fileLabel.textContent = window.bespokeFormStrings.fileSizeExceeded
      fileLabel.classList.add('frm-Form_FileInputLabel-error')
      return
    }

    fileLabel.textContent = file.name

    // Get base64 string of the image
    this.imageBase64 = await this.getBase64(file)

    if (!this.imageBase64) {
      e.target.value = ''
      fileLabel.textContent = window.bespokeFormStrings.failedToEncodeImage
      fileLabel.classList.add('frm-Form_FileInputLabel-error')
      return
    }

    await this.handleFileUpload()

    fileLabel.classList.add('frm-Form_FileInputLabel-uploaded')

    fileLabel.textContent = window.bespokeFormStrings.uploaded

    this.els['file-upload'].element.classList.add('frm-Form_FileInput-done')
  }

  // Handle the file upload when the image is uploaded, rather than when the form is submitted.
  async handleFileUpload () {
    if (!this.imageBase64) {
      console.error('No image data available')
      return
    }

    const formData = new FormData()
    formData.append('file', this.imageBase64)

    try {
      const response = await fetch(
        'https://daniella-draper-klaviyo-script.by-association-only.workers.dev',
        {
          method: 'POST',
          body: formData,
        },
      )

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const result = await response.json()

      const { image_url: imageUrl } = result.data.attributes

      this.uploadedFileUrl = imageUrl
    } catch (error) {
      console.error('Error uploading image to Klaviyo:', error)
    }
  }

  handleProductItemClick (e) {
    e.preventDefault()
    const selectedItem = e.target.closest('.prd-List_Item')
    this.selectedProduct = e.target.href
    const allGridItems = document.querySelectorAll('.prd-List_Item')
    allGridItems.forEach((item) => {
      item.classList.remove('prd-List_Item-active')
    })
    selectedItem.classList.toggle('prd-List_Item-active')
  }

  async filterProducts (filterParams) {
    if (!this.collectionHandle) return

    const sectionElement = document.querySelector('.frm-Form_Grid')
    const queryString = new URLSearchParams(filterParams).toString()
    const collectionToFilter = window.collectionHandleToFilter
    const fetchUrl = `/collections/${collectionToFilter}?${queryString}&section_id=template-collection-product-grid`

    try {
      const response = await fetch(fetchUrl)

      if (!response.ok) {
        throw new Error('Network response was not ok')
      }

      const data = await response.text()
      sectionElement.innerHTML = data

      const productGridItems =
        sectionElement.querySelectorAll('.prd-List_Item')
      productGridItems.forEach((product) => {
        product.addEventListener('click', this.handleProductItemClick)
      })
    } catch (error) {
      console.error('Error loading products:', error)
    }
  }

  async fetchInitialProducts () {
    if (!this.collectionHandle) return

    const sectionElement = document.querySelector('.frm-Form_Grid')
    const fetchUrl = `/collections/${this.collectionHandle}?section_id=template-collection-product-grid`

    try {
      const response = await fetch(fetchUrl)

      if (!response.ok) {
        throw new Error('Network response was not ok')
      }

      const data = await response.text()
      sectionElement.innerHTML = data

      const productGridItems =
        sectionElement.querySelectorAll('.prd-List_Item')
      productGridItems.forEach((product) => {
        product.addEventListener('click', this.handleProductItemClick)
      })
    } catch (error) {
      console.error('Error loading initial products:', error)
    }
  }

  async handleFormSubmit (e) {
    e.preventDefault()

    await this.handleFileUpload()

    const formEmails = this.dataset.emails.split(',')
    const formTitle = this.dataset.title
    const apiVersion = this.dataset.apiVersion

    formEmails.forEach(async (email) => {
      const now = new Date()
      const timestamp = now.getTime()

      const options = {
        method: 'POST',
        headers: {
          accept: 'application/json',
          revision: `${apiVersion}`,
          'content-type': 'application/json',
        },
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              properties: this.getCustomerProperties(),
              time: timestamp / 1000,
              metric: {
                data: { type: 'metric', attributes: { name: formTitle } },
              },
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email,
                  },
                },
              },
            },
          },
        }),
      }

      try {
        const response = await fetch(
          `https://a.klaviyo.com/client/events/?company_id=${this.dataset.companyId}`,
          options,
        )

        if (response.status === 202) {
          this.els.form.element.setAttribute('aria-hidden', 'true')
          this.els.success.element.setAttribute('aria-hidden', 'false')
        } else {
          console.error(response)
        }
      } catch (error) {
        console.error('An error occurred during the fetch operation:', error)
      }
    })
  }

  getCustomerProperties () {
    const properties = {
      $event_id: Math.floor(Math.random() * 2000) + 1,
    }

    if (this.uploadedFileUrl) {
      properties.uploaded_file_url = this.uploadedFileUrl
    }

    if (
      this?.els?.['first-name']?.exists &&
      this.els['first-name'].element.value
    ) {
      properties.customer_first_name = this.els['first-name'].element.value
    }

    if (
      this?.els?.['last-name']?.exists &&
      this.els['last-name'].element.value
    ) {
      properties.customer_last_name = this.els['last-name'].element.value
    }

    if (this?.els?.email?.exists && this.els.email.element.value) {
      properties.customer_email = this.els.email.element.value
    }

    if (this?.els?.phone?.exists && this.els.phone.element.value) {
      properties.customer_phone_number = this.els.phone.element.value
    }

    if (
      this?.els?.['product-type']?.exists &&
      this.els['product-type'].element.value
    ) {
      properties.product_type = this.els['product-type'].element.value
    }

    if (this?.els?.metal?.exists && this.els.metal.element.value) {
      properties.metal = this.els.metal.element.value
    }

    if (this?.els?.stone?.exists && this.els.stone.element.value) {
      properties.stone = this.els.stone.element.value
    }

    if (
      this?.els?.['stone-source']?.exists &&
      this.els['stone-source'].element.value
    ) {
      properties.stone_source = this.els['stone-source'].element.value
    }

    if (this?.els?.budget?.exists && this.els.budget.element.value) {
      properties.budget = this.els.budget.element.value
    }

    if (this?.els?.occasion?.exists && this.els.occasion.element.value) {
      properties.occasion = this.els.occasion.element.value
    }

    if (
      this?.els?.['date-required']?.exists &&
      this.els['date-required'].element.value
    ) {
      properties.date_required = this.els['date-required'].element.value
    }

    if (this?.els?.notes?.exists && this.els.notes.element.value) {
      properties.notes = this.els.notes.element.value
    }

    if (this.selectedProduct) {
      properties.example_product = this.selectedProduct
    }

    if (this?.els?.consent?.exists && this.els.consent.element.checked) {
      properties.consent = this.els.consent.element.checked
    }

    if (
      this?.els?.['staff-store']?.exists &&
      this.els['staff-store'].element.value
    ) {
      properties.staff_store = this.els['staff-store'].element.value
    }

    if (
      this?.els?.['staff-name']?.exists &&
      this.els['staff-name'].element.value
    ) {
      properties.staff_name = this.els['staff-name'].element.value
    }

    if (this?.els?.notes?.exists && this.els.notes.element.value) {
      properties.notes = this.els.notes.element.value
    }

    return properties
  }

  getBase64 (file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = (error) => reject(error)
    })
  }
}

if (!customElements.get('bespoke-form')) {
  customElements.define('bespoke-form', BespokeForm)
}
